import React, { useState } from "react";
import { Link } from "react-router-dom";
import { saveTaskToFirebase } from "../../firebase";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [taskDropdown, setTaskDropdown] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null); // Tracks which task you are filling
  const [taskNote, setTaskNote] = useState("");
  const [hours, setHours] = useState("");

  const handleSave = async () => {
    if (!taskNote || !hours) return alert("Please fill details");
    await saveTaskToFirebase({
      category: selectedTask,
      notes: taskNote,
      duration: hours
    });
    setSelectedTask(null); // Close form after saving
    setTaskNote("");
    setHours("");
    alert("Task Saved Successfully!");
  };

  return (
    <nav className="bg-white border-b border-gray-200 dark:bg-gray-900">
      <div className="max-w-screen-xl mx-auto flex flex-wrap items-center justify-between p-4 relative">
        <a href="/" className="flex items-center space-x-3">
          <img src="https://flowbite.com" className="h-8" alt="Logo" />
          <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
            MyApp
          </span>
        </a>

        <ul className="flex flex-row space-x-8 font-medium">
          <li><Link to="/" className="text-blue-700 dark:text-blue-500">Home</Link></li>
          <li>
            <a href="https://pages.dev" target="_blank" rel="noopener noreferrer" className="text-gray-900 dark:text-white hover:text-blue-700">
              All documents
            </a>
          </li>
          <li><Link to="/drive" className="text-gray-900 dark:text-white hover:text-blue-700">DriveDocuments</Link></li>
          <li><Link to="/dailylearning" className="text-gray-900 dark:text-white hover:text-blue-700">Learn</Link></li>
        </ul>
      </div>

      {/* ✅ Simple form that appears when you select a task */}
      {selectedTask && (
        <div className="p-4 bg-gray-50 border-b border-gray-200 flex flex-col items-center">
          <h3 className="font-bold mb-2">Logging: {selectedTask}</h3>
          <div className="flex space-x-4 mb-2">
            <input
              type="text"
              placeholder="Hours spent"
              className="border p-2 rounded"
              value={hours}
              onChange={(e) => setHours(e.target.value)}
            />
            <input
              type="text"
              placeholder="What logic did you learn?"
              className="border p-2 rounded w-80"
              value={taskNote}
              onChange={(e) => setTaskNote(e.target.value)}
            />
            <button onClick={handleSave} className="bg-blue-600 text-white px-4 py-2 rounded">Save to Firebase</button>
            <button onClick={() => setSelectedTask(null)} className="text-red-500">Cancel</button>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
